import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { fetchHotelDetails } from "../../../../../Redux/slice/features/hotelOccupancySlice";
import DataTable from "../../../../../Common/DataTable/DataTable";
import DataTableHeader from "../../../../../Common/DataTableHeader/DataTableHeader";
import DataTableFooter from "../../../../../Common/DataTableFooter/DataTableFooter";
import { setCurrentPage } from "../../../../../Redux/slice/features/paginationSilce";

const HotelWiseMonthlyDetailTable = () => {
  const dispatch = useDispatch();
  const { hotelId, year, month, hotelDetails,totalCount  } = useSelector((state) => state.hotelOcc);
  
  const currentPage = useSelector((state) => state.pagination.currentPage);
  const itemsPerPage = useSelector((state) => state.pagination.itemsPerPage);

  const monthNames = useMemo(
    () => ["", "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"],
    []
  );


  const columns = useMemo(() => [
    { Header: "SL #", accessor: "sl" },
     {
    Header: "Booking Id",
    accessor: "intBookingId",
    Cell: ({ value }) => (
      <a
        href={`/booking-view/${value}`}
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: "blue", textDecoration: "underline", cursor: "pointer" }}
      >
        {value}
      </a>
    )
  },
    { Header: "Hotel Name", accessor: "UnitName" },
    { Header: "CheckIn Date", accessor: "FromDate" },
    { Header: "CheckOut Date", accessor: "ToDate" },
    { Header: "Booking Ref No", accessor: "vchBookingRefNo" }
  ], []);

  const dataT = useMemo(() => {
    return hotelDetails.map((row, index) => ({
      sl: (currentPage - 1) * itemsPerPage + (index + 1),
      intBookingId: row.intBookingId,
      UnitName: row.UnitName,
      FromDate: row.FromDate,
      ToDate: row.ToDate,
      vchBookingRefNo: row.vchBookingRefNo,
    }));
  }, [hotelDetails, currentPage, itemsPerPage]);

 const { totalPages, currentItems } = useMemo(() => {
  const total = Math.ceil(totalCount / itemsPerPage);  
  return {
    totalPages: total,
    currentItems: dataT 
  };
}, [dataT, totalCount, itemsPerPage]);

 useEffect(() => {
    if (month && year) {
      dispatch(
        fetchHotelDetails({
          hotelId,
          year,
          month,
          pageNo: currentPage,
          recordsPerPage: itemsPerPage,
        })
      );
    }
  }, [dispatch, hotelId, year, month, currentPage, itemsPerPage]);


  const handleNextPage = () => {
    
    if (currentPage < totalPages) {
      dispatch(setCurrentPage(currentPage + 1));
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      dispatch(setCurrentPage(currentPage - 1));
    }
  };

  return (
    <div style={{ position: "relative" }}>
      <div className="report-header">
        <h4>
          Occupancy Detail Report - {monthNames[month]} {year}
          {hotelId === 0 ? " (All Hotels)" : ""}
        </h4>
      </div>

      <DataTableHeader columns={columns} data={dataT} />
      <DataTable columns={columns} data={currentItems} enablePagination={false} />
      <DataTableFooter
        dataT={dataT}
        currentPage={currentPage}
        itemsPerPage={itemsPerPage}
        handleNextPage={handleNextPage}
        handlePreviousPage={handlePreviousPage}
        totalRecords={Number(totalCount)}
      />
    </div>
  );
};

export default HotelWiseMonthlyDetailTable;
